import { Alert } from 'react-native'
import { ApiError } from 'api/error'
import { useSafeAreaInsets as _useSafeAreaInsets } from 'react-native-safe-area-context'
import { getDistance } from 'geolib'
import { compareTwoStrings } from 'string-similarity'
import { PlacePrototype } from 'infra/type'
import { SERVER_BASE_URL } from 'infra/constant'

export const alert = (title: string, message?: string) => {
  Alert.alert(title, message)
}

export const alertError = (error: unknown) => {
  Alert.alert(
    '에러가 발생했어요',
    error instanceof ApiError ? error.message : String(error),
  )
}

export const useSafeAreaInsets = () => {
  const insets = _useSafeAreaInsets()
  // bottom inset is too much
  return { ...insets, bottom: insets.bottom - 12 }
}

export const formatDistance = (distanceInMeters?: number | null) => {
  if (!distanceInMeters) return ''
  if (distanceInMeters >= 1000)
    return `${(distanceInMeters / 1000).toFixed(2)}km`
  return `${distanceInMeters}m`
}

// Provider VO / crawlMissing 과 동일한 이중 임계값:
// 1. 매우 가까우면(≤25m) 이름과 무관하게 같은 장소 (지도 핀 오차 허용)
// 2. 그 외 ≤50m 이면 이름 유사도 ≥0.5 일 때만 같은 장소
export const isSamePlace = (a: PlacePrototype, b: PlacePrototype) => {
  const distance = getDistance(
    { latitude: a.coord.lat, longitude: a.coord.lng },
    {
      latitude: b.coord.lat,
      longitude: b.coord.lng,
    },
  )
  if (distance <= 25) return true
  return distance <= 50 && compareTwoStrings(a.name, b.name) >= 0.5
}

export const getSecureImageUrl = (url?: string) => {
  if (!url) return undefined
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://')
  }
  if (url.startsWith('/')) {
    return `${SERVER_BASE_URL}${url}`
  }
  return url
}
